export default __webpack_public_path__ + "static/media/sat.751acac8.png";